<template>
  <v-container>
    <v-row>
      <v-col class="pa-0">
        <v-text-field
            :label="labelText"
            readonly
            :value="res"
            @click="dialog = true"
            class="rounded-0"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>{{ labelText }}</v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="4">
                <v-text-field
                    v-model="startDateField"
                    :rules="dateRules"
                    @blur="generateResult"
                    label="Дата начала"
                    placeholder="дд.мм.гггг"
                    class="rounded-0"
                />
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                    v-model="endDateField"
                    :rules="dateRules"
                    @blur="generateResult"
                    label="Дата окончания"
                    placeholder="дд.мм.гггг"
                    :disabled="!isRange"
                    class="rounded-0"
                />
              </v-col>
              <v-col cols="12" sm="4">
                <v-switch
                    v-model="isRange"
                    label="Диапазон"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                    label="Результат"
                    :value="res"
                    readonly
                    class="rounded-0"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Отмена</v-btn>
          <v-btn color="blue darken-1" text @click="dialog = false;generateResult()">Сохранить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { extractDatePartsFromStringToObject, dateObjectToString, mergeStartAndEndDatesToString } from "@/helpers/datesUtil"

export default {
  data: () => ({
    startDateField: '',
    endDateField: '',
    dialog: false,
    res: '',
    isRange: false,
    dateRules: [
      (v) => {
        const pattern = /^(\d{1,2})?\.(\d{1,2})?\.(\d{1,4})?$/;
        return pattern.test(v) || 'Неверный формат даты';
      },
    ],
  }),
  props: {
    labelText: {
      type: String,
      default: 'Дата',
    },
    initialDate: {
      type: Object,
      default: null
    }
  },
  methods: {
    generateResult() {
      if (!this.isRange) {
        this.endDateField = this.startDateField;
      }

      const startDateObj = extractDatePartsFromStringToObject(this.startDateField);
      const endDateObj = extractDatePartsFromStringToObject(this.endDateField);

      this.res = mergeStartAndEndDatesToString(startDateObj, endDateObj);
      this.updateDateAtParent(startDateObj, endDateObj);
    },
    updateDateAtParent(startDateObj, endDateObj) {
      this.$emit('emit-method-name', startDateObj, endDateObj);
    },
    setupComponent(initialDate) {
      this.res = mergeStartAndEndDatesToString(initialDate.startDate, initialDate.endDate);
      this.startDateField = dateObjectToString(initialDate.startDate);
      this.endDateField = dateObjectToString(initialDate.endDate);
      this.isRange = this.startDateField !== this.endDateField;
    }
  },

  mounted() {
    if (this.initialDate != null) {
      this.setupComponent(this.initialDate);
    }
  }
};
</script>